<template>
  <div id="app">
    <router-view />
    <!-- 加载路由视图 -->
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(66, 109, 159, 0.12), transparent 24%),
    radial-gradient(circle at top right, rgba(var(--brand-primary-rgb), 0.12), transparent 22%),
    linear-gradient(180deg, #edf1f6 0%, #f5f7fa 50%, #fbfcfd 100%);
  color: var(--ui-ink);
  font-family: "Avenir Next", "SF Pro Display", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

#app {
  min-height: 100vh;
  color: var(--ui-ink);
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(34, 55, 56, 0.18) transparent;
}

*::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

*::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: rgba(34, 55, 56, 0.16);
  background-clip: padding-box;
}

*::-webkit-scrollbar-track {
  background: transparent;
}
</style>
